import React from 'react'
import {useRecoilState} from 'recoil'
import {InputBase} from "../../common";
import {registerFormState} from "./atoms";

type Props = {
    type: string
    name: string
    label: string
    placeholder: string,
    errorMsg: string,
    maxLength?: number
}

const Input: React.FC<Props> = ({type, name, placeholder, label, errorMsg, maxLength}: Props) => {
    const [state, setState] = useRecoilState(registerFormState)

    return (
        <div className={'label_input_wrapper'}>
            <label>
                {label}
            </label>
            <InputBase
                className={'auth_input'}
                type={type}
                name={name}
                placeholder={placeholder}
                state={state}
                setState={setState}
                maxLength={maxLength}
            />
            {errorMsg && <p className={'validation_error_msg'}>{errorMsg}</p>}
        </div>
    )
}

export default Input
